import { ActionButton } from '../common/action_button';

class ConfirmButton extends ActionButton {

  constructor($element) {
    super($element);
  }

  $onInit() {
    this.setDefaults();
    this.overlay = this.findElement('overlay');
    this.okButton = this.findElement('ok');
    this.cancelButton = this.findElement('cancel');

    this.initializeInteractions();
  }

  findElement(clazz) {
    let candidates = this.container.getElementsByClassName(clazz);
    return candidates[0];
  }

  initializeInteractions() {
    let options = {
      capture: true,
      once: true
    };

    let openOverlay = (evt) => {
      this.overlay.classList.add('open');
      setTimeout(() => {
        this.cancelButton.addEventListener('click', cancelListener, options);
        this.okButton.addEventListener('click', okListener, options);
        document.addEventListener('click', dismissListener, {once: true, useCapture: false});
      }, 300);
      evt.stopPropagation();
    };

    let cancelListener = (evt) => {
      closeOverlay(evt);
    };

    let okListener = (evt) => {
      this.execute();
      closeOverlay(evt);
    };

    let dismissListener = (evt) => {
      closeOverlay(evt);
    };

    let closeOverlay = (evt) => {
      evt.stopPropagation();
      this.overlay.classList.remove('open');
      setTimeout(() => {
        document.removeEventListener('click', dismissListener, {once: true, useCapture: false});
        this.cancelButton.removeEventListener('click', cancelListener, options);
        this.okButton.removeEventListener('click', okListener, options);
        this.container.addEventListener('click', openOverlay, options);
      }, 50);
    };

    this.container.addEventListener('click', openOverlay, options);
  }

  setDefaults() {
    if (!this.overlayText) this.overlayText = "Are you sure?";
    if (!this.cancelLabel) this.cancelLabel = "Cancel";
    if (!this.okLabel) this.okLabel = "OK";
  }
}

export default {
  name: 'confirmButton',
  obj: {
    controller: ConfirmButton,
    bindings: {
      action: '&',
      initialText: '<',
      busyText: '<',
      overlayText: '<',
      cancelLabel: '<',
      okLabel: '<',
      icon: '@',
      type: '@',
      risk: '@'
    },
    template: `
      <section ng-class="[$ctrl.type, $ctrl.risk]">
      <button>
          <label class="feedback">{{ $ctrl.initialText }}</label>
          <ng-include ng-if="$ctrl.isIconPresent" class="icon" src="$ctrl.iconPath"></ng-include>
          <ng-include class="icon spinner" src="'/images/spinner.svg'"></ng-include>
      </button>
      <div class="overlay">
          <label>{{ $ctrl.overlayText }}</label>
          <div class="buttons">
              <button class="cancel">{{ $ctrl.cancelLabel }}</button>
              <button class="ok">{{ $ctrl.okLabel }}</button>
          </div>
      </div>
      </section>
    `
  }
}